import moment from "@/moment-gp";
import { mapGetters } from "vuex";
//import { make_block } from "@/components/TodayPage/API/util.js";

import SessionManagementMixin from "@/components/Mixins/SessionManagement"
import SuggestionItemMixin from '@/components/TodayPage/Elements/Suggestions/SuggestionItemMixin.js'

export default {
  mixins: [ SessionManagementMixin, SuggestionItemMixin ],
  data() {
    return {
      google_eventlist: []
    }
  },
  computed: {
    ...mapGetters("calendar", [
      "google_calendar_authorized",
      "google_calendar_auth_date"
    ]),
  },
  methods: {
    async onImportFromGoogleCalendar( currentDate ) {
      console.log("onImportFromGoogleCalendar", currentDate)

      if ( !this.google_calendar_authorized ) {
        this.$alert('Please go to "Setup Connections" (Profile menu) and set up a Google calendar conneciton.', 'Google Calendar not connected');
        return
      }

      let response = await window.gapi.client.calendar.events.list({
          calendarId: "primary",
          timeMin: currentDate.toISOString(),
          timeMax: currentDate.clone().endOf('day').toISOString(),
          showDeleted: false,
          singleEvents: true,
          maxResults: 50,
          orderBy: "startTime"
        })

        let events = response.result.items;
        this.google_eventlist = [];
        events.forEach(event => {
          /* let date = event.start.dateTime
                      ? event.start.dateTime
                      : event.start.date; */

          this.google_eventlist.push({
            id:    event.id,
            start: moment(event.start.dateTime),
            end:   moment(event.end.dateTime),
            url:   event.htmlLink,
            text:  event.summary,
          });
        });

        console.log('google_eventlist', this.google_eventlist)
        this.google_eventlist.forEach(event => {

          //let fixedFrom = event.start.unix();
          //let fixedTo   = event.end.unix();
          /*let block = make_block("EXTERNAL_EVENT", fixedFrom, fixedTo, event.text);

          block.no_drag = true;
          block.config = event;
          block.suggestedFrom = fixedFrom;
          block.suggestedTo = fixedTo;

          this.onAddItem( block, 'auto');*/
          /*let dragItem = { // call "make_task"
            type: "INLINE_TASK",
            title: event.text,
            no_drag: false,
            just_dropped: true,
            config: {
              pack: 'daily-routine-objects-actions',
              icon: '/img/007-umbrella.843a1f65.svg',
              tscColor: 'black',
              title: event.text
            },
            component: "flow-quick-session",
            dragConfig: {
              duration: fixedTo - fixedFrom,
              shiftingEnabled: true,
              placeAtEnd: false
            }
          };
          this.setDragItem(dragItem)
          this.setDragItemType('SESSION')*/

          this.$models.userDayplannerSessions.add({
            dateString:    event.start.format('YYMMDD'),
            from:          event.start.unix(),
            to:            event.end.unix(),
            type:          'INLINE_TASK',
            sortidx:       0.999,
            createdAt:     moment.currentTime().unix(),
            config: {
              //pack: 'icons',
              icon: 'https://seeklogo.net/wp-content/uploads/2017/03/Google-Calendar-icon.png',
              tscColor: 'black',
              title: event.text,
              url: event.url
            }
          })

        })
    },

    onExportToGoogleCalendar( currentDate, dayplan ) {
      console.log("onExportToGoogleCalendar", currentDate, dayplan)

      if ( !this.google_calendar_authorized ) {
        this.$alert('Please go to "Setup Connections" (Profile menu) and set up a Google calendar conneciton.', 'Google Calendar not connected');
        return
      }

      /* const test_event = {
        'summary': 'Testevent TW',
        'location': '27-01 Queens Plaza N, Long Island City, NY 11101, USA',
        'description': 'this is a description',
        'start': {
          'dateTime': '2018-08-27T09:00:00',
          'timeZone': 'Europe/Berlin'
        },
        'end': {
          'dateTime': '2018-08-27T17:00:00',
          'timeZone': 'Europe/Berlin'
        },
        'reminders': {
          'useDefault': false,
          'overrides': [
            {'method': 'email', 'minutes': 24 * 60},
            {'method': 'popup', 'minutes': 10}
          ]
        }
      }; */

      const SKIP_TYPES = [
        'NOT_PLANNED',
        'START_DAY',
        'END_DAY',
        'CURRENT_TIME',
        'TIMESLOT_BREAKER',
        'EXTERNAL_EVENT',
      ];

      let promiseList = []

      dayplan.forEach(event => {
        if ( SKIP_TYPES.includes( event.type ) ) {
          return
        }

        // console.log("EVENT => ", event)

        const event_payload = {
          'summary': event.title,
          // TODO: include tasklist
          'start': {
            'dateTime': moment.unix(event.from).toISOString(),
          },
          'end': {
            'dateTime': moment.unix(event.to).toISOString(),
          },
          "reminders": {
            "useDefault": true
          },
          /*"description": "Synced with Goalpilot",
          "gadget": {
            "iconLink": "https://i.ibb.co/mBSY7nT/favicon-32x32.png",
            "link": "https://i.ibb.co/mBSY7nT/favicon-32x32.png",
            "title": "Synced from Goalpilot",
            "type": "image/ico",
            "height": 32,
            "width": 32,
            "display": "icon",
          },
          "source.url": "https://www.goalpilot.com"*/
        };

        // console.log("event_payload => ", event_payload)

        let promise = new Promise((resolve, reject) => {
          window.gapi.client.calendar.events.insert({
            'calendarId': 'primary',
            'resource': event_payload
          }).execute((event) => {
            resolve(event)
            // console.log("event", event);
          });
        })

        promiseList.push( promise );
      })

      return Promise.all(promiseList).then(() => {
        this.$message({
          message: 'Todays plan was successfully exported to Google Calendar.',
          type: 'success'
        });
      })
    }
  }
}
